import { render, staticRenderFns } from "./ClientEmail.vue?vue&type=template&id=12e1c392&scoped=true"
import script from "./ClientEmail.vue?vue&type=script&lang=js"
export * from "./ClientEmail.vue?vue&type=script&lang=js"
import style0 from "./ClientEmail.vue?vue&type=style&index=0&id=12e1c392&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e1c392",
  null
  
)

export default component.exports